import React, { useEffect, useState } from 'react';
import { Navigate, useLocation ,useNavigate} from 'react-router-dom';
import ApprovalProcessService from '../services/ApprovalProcessService';

const RouteGuard = ({ children }) => {
    const navigate = useNavigate();
  const [allowedPaths, setAllowedPaths] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const empcode = localStorage.getItem('empcode');

  useEffect(() => {
    const username = localStorage.getItem('username');
    const empCode = localStorage.getItem('empcode');
    const token = localStorage.getItem('token');

    if (!username || !empCode || !token) {
      // Redirect to login if any of them is blank or missing
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
       
        const res = await ApprovalProcessService.getMenuListData(empcode);
        const paths = res.data.result
          .filter(menu => menu.menuPath) // only routes with paths
          .map(menu => menu.menuPath.toLowerCase());
        setAllowedPaths(paths);
      } catch (err) {
        console.error("Menu load failed", err);
        setAllowedPaths([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [empcode]);

  if (loading) return null; // or spinner

  const currentPath = location.pathname.toLowerCase();
  return allowedPaths.includes(currentPath) ? children : <Navigate to="/home" replace />;
};

export default RouteGuard;